import {ngAsync} from 'shared/utils/ng-@decorators';
import {responseToData, unRestangularize} from 'shared/utils/data-service-utils';
import type {Directory, DirectoryInsight, FinishedActionResponse, FinishedSaveResponse} from 'typings/portaro.be.types';

export class DirectoryDataService {
    public static serviceName = 'directoryDataService';

    public static readonly ROUTE = 'directories';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getDirectoryById(id: number): Promise<Directory> {
        try {
            return await this.Restangular
                .one(DirectoryDataService.ROUTE, id)
                .get();
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async getDirectoryTree(rootDirectoryId: number): Promise<unknown> {
        try {
            return await this.Restangular
                .one(DirectoryDataService.ROUTE, rootDirectoryId)
                .one('tree')
                .get();
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async getInsight(directoryId: number, forbiddenFileId: number): Promise<DirectoryInsight> {
        try {
            return await this.Restangular
                .one(DirectoryDataService.ROUTE, directoryId)
                .one('insight')
                .get({forbiddenFile: forbiddenFileId});
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async createSubdirectory(parentDirectoryId: number, name?: string): Promise<FinishedSaveResponse<Directory>> {
        try {
            return await this.Restangular
                .all(DirectoryDataService.ROUTE)
                .all('new')
                .post({parentDirectory: parentDirectoryId, name});
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async editDirectory(directory: Directory): Promise<FinishedActionResponse> {
        try {
            return await this.Restangular
                .all(DirectoryDataService.ROUTE)
                .post({
                    directory: directory.id,
                    name: directory.name,
                    order: directory.order,
                    accessType: directory.accessType.id,
                    confirmed: false
                });
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async deleteDirectory(directory: Directory): Promise<FinishedActionResponse> {
        try {
            return await this.Restangular
                .one(DirectoryDataService.ROUTE, directory.id)
                .remove();
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }
}